export default __webpack_public_path__ + "static/media/ic_bookings_blue.ec1729ae.svg";